import React from 'react';
import PropTypes from 'prop-types';

const MobileappIcon = ({ className }) => {
    return (
        <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 0C0.669 0 0 0.669 0 1.5V16.5C0 17.331 0.669 18 1.5 18H10.5C11.331 18 12 17.331 12 16.5V1.5C12 0.669 11.331 0 10.5 0H1.5ZM2.25 1.5H9.75C10.1655 1.5 10.5 1.8345 10.5 2.25V12.75C10.5 13.1655 10.1655 13.5 9.75 13.5H2.25C2.05109 13.5 1.86032 13.421 1.71967 13.2803C1.57902 13.1397 1.5 12.9489 1.5 12.75V2.25C1.5 1.8345 1.8345 1.5 2.25 1.5ZM5.25 15H6.75C6.94891 15 7.13968 15.079 7.28033 15.2197C7.42098 15.3603 7.5 15.5511 7.5 15.75C7.5 15.9489 7.42098 16.1397 7.28033 16.2803C7.13968 16.421 6.94891 16.5 6.75 16.5H5.25C5.05109 16.5 4.86032 16.421 4.71967 16.2803C4.57902 16.1397 4.5 15.9489 4.5 15.75C4.5 15.5511 4.57902 15.3603 4.71967 15.2197C4.86032 15.079 5.05109 15 5.25 15Z" fill="#228EBC" />
        </svg>

    );
};

MobileappIcon.propTypes = {
    className: PropTypes.string
};

export default MobileappIcon
